import {
	PasswordChangeAction,
	ChangePasswordError,
} from './change-password';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_UNAUTHORIZED, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

const successMock: PasswordChangeAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_NO_CONTENT,
	});
};

const unauthorizedMock: PasswordChangeAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_UNAUTHORIZED,
		error: ChangePasswordError.Unauthorized,
	});
};

const validationErrorMock: PasswordChangeAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		error: ChangePasswordError.EmailInvalid,
	});
};

const internalErrorMock: PasswordChangeAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
	});
};

export const changePasswordMocks: {
	success: PasswordChangeAction;
	unauthorized: PasswordChangeAction;
	validationError: PasswordChangeAction;
	internalError: PasswordChangeAction;
	fail: PasswordChangeAction;
} = {
	success: successMock,
	unauthorized: unauthorizedMock,
	validationError: validationErrorMock,
	internalError: internalErrorMock,
	fail: internalErrorMock,
};
